module.exports = __webpack_public_path__ + "img/minus_btn.08ca605d.png";